<template>
  <div class="home">
    <section class="hero">
      <h1 class="no-wrap">{{ $t('home.title') }}</h1>
      <p>{{ $t('home.subtitle') }}</p>
      <div class="hero-buttons">
        <router-link to="/about#contact-us" class="cta-button">{{ $t('home.cta') }}</router-link>
      </div>
    </section>

    <section class="highlights">
      <div class="highlight-item">
        <div class="highlight-icon">
          <img src="../assets/images/acceleration.svg" alt="Acceleration"/>
        </div>
        <h3>{{ $t('home.highlights.acceleration.title') }}</h3>
        <p>{{ $t('home.highlights.acceleration.desc') }}</p>
      </div>
      <div class="highlight-item">
        <div class="highlight-icon">
          <img src="@/assets/images/security.svg" alt="Security"/>
        </div>
        <h3>{{ $t('home.highlights.security.title') }}</h3>
        <p>{{ $t('home.highlights.security.desc') }}</p>
      </div>
      <div class="highlight-item">
        <div class="highlight-icon">
          <img src="@/assets/images/smart.svg" alt="Smart"/>
        </div>
        <h3>{{ $t('home.highlights.scheduling.title') }}</h3>
        <p>{{ $t('home.highlights.scheduling.desc') }}</p>
      </div>
    </section>

    <section class="services">
      <div class="section-header">
        <h2>{{ $t('home.services.title') }}</h2>
        <p>{{ $t('home.services.subtitle') }}</p>
      </div>

      <div class="services-grid">
        <div class="service-card">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" width="32" height="32">
              <path d="M3 12h18M3 6h18M3 18h18"
                    stroke="currentColor"
                    fill="none"
                    stroke-width="2"
                    stroke-linecap="round"/>
            </svg>
          </div>
          <h3>{{ $t('home.services.items.cdn.title') }}</h3>
          <p>{{ $t('home.services.items.cdn.desc') }}</p>
        </div>

        <div class="service-card">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" width="32" height="32">
              <path d="M12 20v-6M12 4v2m0 4v2m0 4v2m0 4v2"
                    stroke="currentColor"
                    fill="none"
                    stroke-width="2"
                    stroke-linecap="round"/>
              <circle cx="12" cy="12" r="10"
                      stroke="currentColor"
                      fill="none"
                      stroke-width="2"/>
            </svg>
          </div>
          <h3>{{ $t('home.services.items.security.title') }}</h3>
          <p>{{ $t('home.services.items.security.desc') }}</p>
        </div>

        <div class="service-card">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" width="32" height="32">
              <path d="M12 2a10 10 0 0 0-7.07 17.07l1.42-1.42A8 8 0 1 1 12 4v2l3-3-3-3v2z"
                    stroke="currentColor"
                    fill="none"
                    stroke-width="2"
                    stroke-linecap="round"/>
              <path d="M12 12l-3 3m0-6l3 3m6 0l-3 3m0-6l3 3"
                    stroke="currentColor"
                    fill="none"
                    stroke-width="2"
                    stroke-linecap="round"/>
            </svg>
          </div>
          <h3>{{ $t('home.services.items.edgeComputing.title') }}</h3>
          <p>{{ $t('home.services.items.edgeComputing.desc') }}</p>
        </div>
      </div>
    </section>

    <section class="advantages">
      <div class="section-header">
        <h2>{{ $t('home.advantages.title') }}</h2>
        <p>{{ $t('home.advantages.subtitle') }}</p>
      </div>

      <div class="advantages-grid">
        <div class="advantage-card">
          <div class="advantage-icon">
            <svg viewBox="0 0 24 24" width="32" height="32">
              <path d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
                    stroke="currentColor"
                    fill="none"
                    stroke-width="2"
                    stroke-linecap="round"/>
            </svg>
          </div>
          <h3>{{ $t('home.advantages.items.realtime.title') }}</h3>
          <p>{{ $t('home.advantages.items.realtime.desc') }}</p>
        </div>

        <div class="advantage-card">
          <div class="advantage-icon">
            <svg viewBox="0 0 24 24" width="32" height="32">
              <path d="M13 10V3L4 14h7v7l9-11h-7z"
                    stroke="currentColor"
                    fill="none"
                    stroke-width="2"
                    stroke-linecap="round"/>
            </svg>
          </div>
          <h3>{{ $t('home.advantages.items.performance.title') }}</h3>
          <p>{{ $t('home.advantages.items.performance.desc') }}</p>
        </div>

        <div class="advantage-card">
          <div class="advantage-icon">
            <svg viewBox="0 0 24 24" width="32" height="32">
              <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                    stroke="currentColor"
                    fill="none"
                    stroke-width="2"/>
              <path
                  d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"/>
            </svg>
          </div>
          <h3>{{ $t('home.advantages.items.stability.title') }}</h3>
          <p>{{ $t('home.advantages.items.stability.desc') }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  mounted() {
    this.updateTitle();
  },
  watch: {
    '$i18n.locale': 'updateTitle'
  },
  methods: {
    updateTitle() {
      document.title = this.$t('pageTitle');
    }
  }
}
</script>

<style scoped>
.home {
  background-color: var(--background-light);
  min-height: 100vh;
}

.hero {
  text-align: center;
  padding: 4rem 2rem;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
  color: white;
  margin-bottom: 3rem;
}

.hero h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-weight: 700;
}

.hero p {
  font-size: 1.2rem;
  opacity: 0.9;
}

.hero-buttons {
  margin-top: 2rem;
}

.cta-button {
  padding: 0.9rem 2.2rem;
  font-size: 1.1rem;
  background-color: white;
  color: var(--primary-color);
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  text-decoration: none;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.highlights {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  padding: 4rem 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.highlight-item {
  padding: 2.5rem;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid var(--border-color);
}

.highlight-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}

.highlight-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
}

.highlight-icon img {
  width: 64px;
  height: 64px;
  transition: transform 0.3s ease;
}

.highlight-item:hover .highlight-icon img {
  transform: scale(1.1);
}

.highlight-item h3 {
  display: flex;
  justify-content: center;
  color: var(--text-primary);
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.highlight-item p {
  color: var(--text-secondary);
  line-height: 1.6;
}

@media (max-width: 768px) {
  .highlights {
    grid-template-columns: 1fr;
  }

  .hero {
    padding: 4rem 1rem;
    /*min-height: 400px;*/
  }

  .hero h1 {
    font-size: 2.2rem;
  }

  .hero p {
    font-size: 1rem;
  }

  .cta-button {
    padding: 0.8rem 2rem;
    font-size: 1rem;
  }
}

.advantages {
  padding: 3rem 2rem 4rem;
  background-color: var(--background-gray);
}

.section-header {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 4rem;
}

.section-header h2 {
  font-size: 2.5rem;
  color: var(--text-primary);
  margin-bottom: 1rem;
}

.section-header p {
  font-size: 1.1rem;
  color: var(--text-secondary);
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.advantage-card {
  background: white;
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid var(--border-color);
}

.advantage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}

.advantage-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background-gray);
  border-radius: 50%;
  color: var(--primary-color);
  transition: all 0.3s ease;
}

.advantage-card:hover .advantage-icon {
  background: var(--primary-color);
  color: white;
}

.advantage-card h3 {
  color: var(--text-primary);
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.advantage-card p {
  color: var(--text-secondary);
  line-height: 1.6;
}

@media (max-width: 768px) {
  .advantages {
    padding: 4rem 1rem;
  }

  .section-header h2 {
    font-size: 2rem;
  }

  .advantages-grid {
    grid-template-columns: 1fr;
  }
}

.services {
  padding: 2rem 2rem 4rem;
  background-color: var(--background-light);
}

.section-header {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 4rem;
}

.section-header h2 {
  font-size: 2.5rem;
  color: var(--text-primary);
  margin-bottom: 1rem;
}

.section-header p {
  font-size: 1.1rem;
  color: var(--text-secondary);
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.service-card {
  background: white;
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid var(--border-color);
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}

.service-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background-gray);
  border-radius: 50%;
  color: var(--primary-color);
  transition: all 0.3s ease;
}

.service-card:hover .service-icon {
  background: var(--primary-color);
  color: white;
}

.service-card h3 {
  color: var(--text-primary);
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.service-card p {
  color: var(--text-secondary);
  line-height: 1.6;
}

@media (max-width: 768px) {
  .services {
    padding: 4rem 1rem;
  }

  .section-header h2 {
    font-size: 2rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
  }
}

.no-wrap {
  white-space: nowrap;
}

.social-media {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}

.social-media span {
  font-size: 1.2rem;
  color: var(--text-primary);
  font-weight: 500;
}

.logo {
  width: 150px;
  height: auto;
  display: block;
  margin: 0 auto;
}
</style> 